import * as React from 'react';
import { ThemeContext } from 'styled-components';

type Props = {
  factor: number;
};

const Spacing: React.FC<Props> = ({ factor }) => {
  const theme = React.useContext(ThemeContext);
  return <div style={{ width: '100%', height: theme.spacing(factor) }} />;
};

export default Spacing;
